import React, { useState } from "react";

import formStructure from "./constants/formStructure";
import Form from "./form";
import Radio from "../../../../genericInputFields/radio/radio.component";

import { ContainerStyledWrapper, AccordionContent } from "./container.style";
import Section from "../../../formComponents/section/section.component";
import useAppContext from "../../../../../hooks/useAppContext";

const Container = () => {
  const { axios } = useAppContext();
  const [formType, setFormType] = useState("team");
  const [serverErrors, setServerErrors] = useState(null);
  const options = [
    {
      label: "New company",
      value: "company",
    },
    {
      label: "New team",
      value: "team",
    },
  ];

  const onTypeChange = (e) => setFormType(e.target.value);
  const onSubmit = (data, reset) => {
    setServerErrors(null);
    const formData = new FormData();
    formData.append("form_type", formType);
    Object.entries(data).forEach(([key, value]) => {
      if (value) formData.append(key, value);
    });
    axios
      .post("/admin/companies", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        reset();
        setFormType("team");
        const { redirectTo } = resp.data.data;
        if (window) window.location.assign(redirectTo);
      })
      .catch((err) => setServerErrors(err.response.data.data.errors));
  };

  return (
    <ContainerStyledWrapper>
      <AccordionContent>
        <Section
          data={{
            name: "New company or team",
            description:
              "Are you creating a new company or a team from an existing company?",
            required: true,
          }}
        >
          {options.map((item, idx) => (
            <Radio
              key={idx}
              name="formType"
              value={item.value}
              onChange={onTypeChange}
              checked={formType === item.value}
              label={item.label}
            />
          ))}
        </Section>
      </AccordionContent>
      <Form
        onPostForm={onSubmit}
        structure={formStructure[formType]}
        formType={formType}
        serverErrors={serverErrors}
      />
    </ContainerStyledWrapper>
  );
};

export default Container;
